module.exports = __webpack_public_path__ + "img/macao.7d52d86.webp";